import React, { useState } from 'react';
import { FaTerminal, FaCode, FaDatabase, FaCloud, FaNetworkWired, FaGraduationCap, FaMapMarkerAlt, FaClock, FaStar } from 'react-icons/fa';
import './Education.css';

export default function EducationCard() {
  const [currentDirectory] = useState("~/education");

  return (
    <section id="education" className="education-section">
      <div className="terminal-window">
        <div className="terminal-bar">
          <div className="terminal-buttons">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="terminal-title">
            <FaTerminal /> education.sh — {currentDirectory}
          </div>
        </div>
        
        <div className="terminal-content">
          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">cat university_info.json</span>
          </div>
          
          <div className="output-block">
            <div className="json-content">
              <div className="university-logo">
                <img src="pes.png" alt="PESU Logo" />
              </div>
              
              <div className="education-info">
                <div className="info-item">
                  <FaGraduationCap className="info-icon" />
                  <div className="info-text">
                    <h3>PES University</h3>
                    <p>Bachelor of Technology</p>
                  </div>
                </div>
                
                <div className="info-item">
                  <FaCode className="info-icon" />
                  <div className="info-text">
                    <p>Computer Science and Engineering</p>
                  </div>
                </div>

                <div className="info-item">
                  <FaClock className="info-icon" />
                  <div className="info-text">
                    <p>2022 - 2026</p>
                    <span className="status">In Progress</span>
                  </div>
                </div>

                <div className="info-item">
                  <FaStar className="info-icon" />
                  <div className="info-text">
                    <p>CGPA: 8.42</p>
                  </div>
                </div>

                <div className="info-item">
                  <FaMapMarkerAlt className="info-icon" />
                  <div className="info-text">
                    <p>Bangalore, India</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">ls -la ./courses/</span>
          </div>
          
          <div className="output-block">
            <div className="course-list">
              <div className="course-item">
                <FaCode /> Data Structures & Algorithms
              </div>
              <div className="course-item">
                <FaTerminal /> Operating Systems
              </div>
              <div className="course-item">
                <FaDatabase /> Database Management
              </div>
              <div className="course-item">
                <FaNetworkWired /> Computer Networks
              </div>
              <div className="course-item">
                <FaCode /> Web Technologies
              </div>
              <div className="course-item">
                <FaCode /> Object Oriented Programming
              </div>
              <div className="course-item">
                <FaDatabase /> Big Data
              </div>
              <div className="course-item">
                <FaCloud /> Cloud Computing
              </div>
            </div>
          </div>

          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">pwd</span>
            <div className="path-output">
              /education/2022-2026/btech/cse
            </div>
          </div>

          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="cursor">|</span>
          </div>
        </div>
      </div>
    </section>
  );
}
